<script setup lang="ts">
import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/vue'

const model = defineModel()
defineProps<{
	options: any
	optionsKey?: string // default value
	optionsDisplay?: string // default label
	optionsValue?: string //save a different value to the key
	name?: string
	label?: string
	labelPosition?: "stacked" | "floating" | "fixed" | undefined
	placeholder?: string
}>()

</script>

<template>
	<ion-item>
		<ion-label v-if="label" :position="labelPosition ?? 'stacked'" class="form-label">{{ label }}</ion-label>
		<ion-select
			:name="name"
			v-model="model"
			class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
			:placeholder="placeholder"
		>
			<ion-select-option v-for="d in options" :key="d[optionsKey ?? 'value']" :value="d[optionsValue ?? optionsKey  ?? 'value']">
				{{ d[optionsDisplay ?? 'label'] }}
			</ion-select-option>
		</ion-select>
	</ion-item>
</template>

